<template>
  
<FormKitLazyProvider>
<FormKit
    type="select"
    :name="option.option_id"
    :label="optionLabel"
    :options="dropDownOptions"
  />
</FormKitLazyProvider>

</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const { option } = defineProps({
  option: {
    type: Object,
    required: true,
  },
})

const optionLabel = computed<string>(() =>
  option.title?.split('|')?.[0] || option.title,
)

const dropDownOptions = computed<never[]>(() =>
  option.dropdownValue.map((item: never) => {
    return { label: item.title, value: String(item.option_type_id) }
  }),
)
</script>
